<template>
  <div class="modal zoom" tabindex="-1" role="dialog" id="modalNaoExportou"> 
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-left">Fichas de Aprovação que não foram exportadas</h4> 
        </div>
        <div class="modal-body"> 
          <table>
            <tbody>
              <tr v-for="f in fichas" :key="f">
                <td style="color:red;"><i class="fa fa-remove" aria-hidden="true"></i> &nbsp;</td>
                <td style="padding:2px 0">Não conseguimos exportar a ficha <strong> {{f}} </strong> </td>
              </tr>
            </tbody>
          </table> 
          <small style="font-size:11.5px">Tente novamente mais tarde. Caso o problema persista, por favor, entre em contato com a área de Projetos.</small>
        </div>
        <div class="modal-footer"> 
          <button type="button" class="btn btn-default" data-dismiss="modal" >Fechar</button>   
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
export default {
  props: ['fichas']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NaoExportou.vue?1be6bf1e